// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__347kb","overflowing":"ReadFullNote_overflowing__arf_t"};